/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var CompareArrowsOutlineIcon = function CompareArrowsOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M10.3854 17.7573L8.02195 20.3223L9.49276 21.6776L14.0265 16.7573L9.49276 11.837L8.02195 13.1923L10.3855 15.7573H2V17.7573H10.3854Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6145 8.24248H22V6.24248H13.6146L15.9781 3.67752L14.5072 2.32227L9.97355 7.24253L14.5072 12.1628L15.9781 10.8075L13.6145 8.24248Z"
  }));
};
export default CompareArrowsOutlineIcon;